import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { X, Mail, Sparkles } from "lucide-react";
import { toast } from "sonner";

const KEY = "bf_subscribed";

export default function EmailCapture() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setShow(true), 8000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/subscribers", { email });
      setDone(true);
      localStorage.setItem(KEY, "1");
      toast.success("Boggy is on it · check your inbox");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Try again");
    } finally { setLoading(false); }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[60] bg-[#1A1A1A]/60 flex items-center justify-center p-4" data-testid="email-capture">
      <div className="brut bg-paper w-full max-w-md p-6 relative">
        <button onClick={dismiss} className="absolute -top-4 -right-4 brut-btn bg-white p-2" data-testid="email-capture-close" aria-label="close">
          <X size={18} strokeWidth={3} />
        </button>
        {!done ? (
          <>
            <span className="tag-sticker bg-yellow text-xl rotate-tilt-l inline-block mb-3 flex items-center gap-1 w-fit">
              <Sparkles size={16} strokeWidth={3} /> first-fit deal
            </span>
            <h2 className="font-display text-3xl uppercase">Get $5 off your first fit</h2>
            <p className="mt-2">Drop your email — Boggy will text you (well, email you) the code <strong className="bg-cyan border-2 border-[#1A1A1A] px-1">WELCOME5</strong> for $5 off $20+.</p>
            <form onSubmit={submit} className="mt-5 flex flex-col gap-3">
              <div className="brut-input flex items-center gap-2">
                <Mail size={18} strokeWidth={3} />
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="bg-transparent outline-none w-full"
                  data-testid="email-capture-input"
                />
              </div>
              <button disabled={loading} type="submit" className="brut-btn bg-orange text-white py-3" data-testid="email-capture-submit">
                {loading ? "Sending…" : "Send me the code"}
              </button>
              <button type="button" onClick={dismiss} className="text-sm font-bold underline" data-testid="email-capture-dismiss">Maybe later</button>
            </form>
          </>
        ) : (
          <div className="text-center py-4">
            <span className="tag-sticker bg-green text-xl rotate-tilt-r inline-block mb-3">sent!</span>
            <h2 className="font-display text-3xl uppercase">Check your inbox</h2>
            <p className="mt-2">Boggy just emailed you the code. Now go shop.</p>
            <button onClick={dismiss} className="brut-btn bg-orange text-white px-6 py-3 mt-5">Hop the rack</button>
          </div>
        )}
      </div>
    </div>
  );
}
